import React, { useState, useEffect } from "react";

import axios from "../../../axios/index";
import parse from "html-react-parser";
import { Link } from "react-router-dom";

// styles
import ModalStyles from "../../Dashboard/DashboardReuseAbleComponents/Modal.module.css";
import Dstyles from "../UserFilesDetail/UserFilesDetail.module.css";
import styles from "../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css";

// components
import Modal from "react-bootstrap/Modal";
import CardSlider from "../../Dashboard/DashboardFileManagement/CardDetail/CardSlider";
import FileFacilities from "../../Dashboard/DashboardFileManagement/CardDetail/FileFacilities";

//Images
import bedIcon from "../../../assets/img/DashboardICons/bedIcon.svg";
import meterIcon from "../../../assets/img/DashboardICons/meterIcon.svg";
import buildingIcon from "../../../assets/img/DashboardICons/buildingIcon.svg";
import locationIcon from "../../../assets/img/DashboardICons/locationIcon.svg";
import calenderIcon from "../../../assets/img/DashboardICons/CalenderIcon.svg";

const FastViewModal = props => {
  const fileID = props.id;
  const e2p = s => s?.toString()?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d]);
  const [fileData, setFileData] = useState([]);
  const [addedFacilitiesID, setAddedFacilitiesID] = useState([]);
  const [facilitiData, setFacilitiData] = useState();
  const [addedFacilities, setAddedFacilities] = useState([]);

  useEffect(() => {
    if (props.show) {
      const getData = async () => {
        const getApiData = await axios.get(`Estate/${fileID}`);
        const getApiDataFacilities = await axios.get(
          `Specification/GetList?categoryId=${getApiData.data.data.categoryId}&subCategoryId=${getApiData.data.data.subCategoryId}`
        );
        const filteredFacilities = getApiData.data.data.facilities.split(",") ?? [];
        setAddedFacilities(filteredFacilities);
        // console.log("res", getApiDataFacilities.data.data);
        setFacilitiData(getApiDataFacilities.data.data);
        const filterdObjects = getApiDataFacilities.data.data.filter(obj => {
          return filteredFacilities.includes(obj.title);
        });
        // console.log(filterdObjects);
        setAddedFacilitiesID(filterdObjects.map(item => item.id));

        setFileData(getApiData.data.data);
      };

      getData();
    }
  }, [fileID, props.show]);

  console.log("first", facilitiData, fileData, addedFacilitiesID, addedFacilities);

  return (
    <>
      <style type="text/css">
        {`
            .modal {
                background: #393939;
            }

            .modal-content {
                border-radius: 24px;
            }

            .modal-header {
                align-items: center !important;
            }

            .modal-dialog-centered {
                justify-content: center !important;
            }

            @media only screen and (min-width: 768.98px) {
                .modal-content {
                    width: 942px;
                }
            }

            @media only screen and (max-width: 768.98px) {
                .modal-content {
                width: calc(100% - 1.5rem) !important;
                }
            }

        `}
      </style>

      <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton dir="rtl" style={{ border: "none" }}>
          <div className="w-100 d-flex align-items-start justify-content-between px-3">
            <div className={ModalStyles.title}>مشاهده سریع</div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="w-100 d-flex flex-column align-items-center justify-content-center px-3" style={{ background: "#FFFFFF" }}>
            <div className="container py-3 px-0">
              {/* <div className="container-fluid"> */}
              <div className="w-100 d-flex justify-content-md-between justify-content-center flex-wrap flex-md-row flex-column align-items-center" dir="rtl">
                <CardSlider images={fileData?.images} image={fileData?.imageUrl} wFull />

                {props.landing ? (
                  <div className="w-100 d-flex align-items-center justify-content-start flex-wrap my-3">
                    <div className={`w-100 d-flex align-items-center justify-content-between flex-wrap py-3 px-4 ${Dstyles.pricesdata_container}`}>
                      <div className="d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2">
                        <div className={`ms-2 ${Dstyles.text_gray}`}>قیمت شروع:</div>
                        <div className={Dstyles.text_title}>{e2p(fileData?.priceFrom?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))}</div>
                        <span className={`me-1 ${Dstyles.text_gray}`}>
                          {fileData.estatePriceType == "1"
                            ? "تومان"
                            : fileData.estatePriceType == "2"
                            ? "لیر"
                            : fileData.estatePriceType == "3"
                            ? "دلار"
                            : fileData.estatePriceType == "4" && "پوند"}
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2">
                        <div className={`ms-2 ${Dstyles.text_gray}`}>قیمت پایان:</div>
                        <div className={Dstyles.text_title}>{e2p(fileData?.toPrice?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))}</div>
                        <span className={`me-1 ${Dstyles.text_gray}`}>
                          {fileData.estatePriceType == "1"
                            ? "تومان"
                            : fileData.estatePriceType == "2"
                            ? "لیر"
                            : fileData.estatePriceType == "3"
                            ? "دلار"
                            : fileData.estatePriceType == "4" && "پوند"}
                        </span>
                      </div>
                      <div className="w-100 d-flex align-items-center justify-content-start mt-3 mb-3 mx-md-0 mx-2">
                        <div className={`ms-2 ${Dstyles.text_gray}`}>توضیحات:</div>
                        <div className={Dstyles.text_title_sm}>
                          {fileData?.description ? parse(`<body className=${styles.body_container}>${fileData?.description}</body>`) : parse("")}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="w-100 d-flex align-items-center justify-content-start flex-wrap my-3">
                    {fileData?.totalPrice ? (
                      <div className={`w-100 d-flex align-items-center justify-content-between flex-wrap p-3 ${Dstyles.pricesdata_container}`}>
                        <div className="d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2">
                          <div className={`ms-2 ${Dstyles.text_gray}`}>قیمت کل:</div>
                          <div className={Dstyles.text_title}>{e2p(fileData?.totalPrice?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))}</div>
                          <span className={`me-1 ${Dstyles.text_gray}`}>تومان</span>
                        </div>
                        <div className="d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2">
                          <div className={`ms-2 ${Dstyles.text_gray}`}>قیمت هر متر:</div>
                          <div className={Dstyles.text_title_sm}>
                            {e2p(fileData?.meteragePrice?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))} تومان هر متر مربع
                          </div>
                        </div>
                        <div className="w-100 d-flex align-items-center justify-content-start mt-3 mb-3 mx-md-0 mx-2">
                          <div className={`ms-2 ${Dstyles.text_gray}`}>آدرس حدودی:</div>
                          <div className={Dstyles.text_title_sm}>{e2p(fileData?.address?.shortAddress)}</div>
                        </div>
                      </div>
                    ) : (
                      <div className={`w-100 d-flex align-items-center justify-content-between flex-wrap p-3 ${Dstyles.pricesdata_container}`}>
                        <div className="d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2">
                          <div className={`ms-2 ${Dstyles.text_gray}`}>رهن:</div>
                          <div className={Dstyles.text_title}>{e2p(fileData?.mortgagePrice?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))}</div>
                          <span className={`me-1 ${Dstyles.text_gray}`}>تومان</span>
                        </div>
                        <div className="d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2">
                          <div className={`ms-2 ${Dstyles.text_gray}`}>اجاره ماهانه:</div>
                          <div className={Dstyles.text_title}>{e2p(fileData?.rentPrice?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))}</div>
                          <span className={`me-1 ${Dstyles.text_gray}`}>تومان</span>
                        </div>
                        <div className="w-100 d-flex align-items-center justify-content-start mt-3 mb-3 mx-md-0 mx-2">
                          <div className={`ms-2 ${Dstyles.text_gray}`}>آدرس حدودی:</div>
                          <div className={Dstyles.text_title_sm}>{e2p(fileData?.address?.fullAddress)}</div>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {props.landing ? (
                  <></>
                ) : (
                  <div className="w-100 d-flex align-items-center justify-content-start flex-wrap my-3">
                    {/* <div className='w-100 d-flex align-items-center justify-content-center flex-wrap mt-3 mb-2 px-3'> */}
                    <hr className="solid w-100" />
                    <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap mt-2 mb-2 px-3">
                      <div className={`d-flex align-items-center justify-content-center my-md-2 my-3 mx-md-0 mx-3 ${Dstyles.facilities_card_container}`}>
                        <div className={`d-flex align-items-center justify-content-center ${Dstyles.icon_bg}`}>
                          <img src={bedIcon} alt="icon" />
                        </div>
                        <div className="d-flex align-items-start justify-content-center flex-column me-3">
                          <span className={Dstyles.text_gray}>تعداد اتاق</span>
                          <span className={`me-0 mt-1 ${Dstyles.text_title_sm}`}>{e2p(fileData.roomCount?.toString())} خوابه</span>
                        </div>
                      </div>

                      <div className={`d-flex align-items-center justify-content-center my-md-2 my-3 mx-md-0 mx-3 ${Dstyles.facilities_card_container}`}>
                        <div className={`d-flex align-items-center justify-content-center ${Dstyles.icon_bg}`}>
                          <img src={meterIcon} alt="icon" />
                        </div>
                        <div className="d-flex align-items-start justify-content-center flex-column me-3">
                          <span className={Dstyles.text_gray}>متراژ کل</span>
                          <span className={`me-0 mt-1 ${Dstyles.text_title_sm}`}>{e2p(fileData.meterage?.toString())} متر</span>
                        </div>
                      </div>

                      <div className={`d-flex align-items-center justify-content-center my-md-2 my-3 mx-md-0 mx-3 ${Dstyles.facilities_card_container}`}>
                        <div className={`d-flex align-items-center justify-content-center ${Dstyles.icon_bg}`}>
                          <img src={buildingIcon} alt="icon" />
                        </div>
                        <div className="d-flex align-items-start justify-content-center flex-column me-3">
                          <span className={Dstyles.text_gray}>طبقه</span>
                          <span className={`me-0 mt-1 ${Dstyles.text_title_sm}`}>
                            {fileData.floor == "0" ? "همکف" : fileData.floor == "-1" ? "زیرزمین" : <>طبقه {e2p(fileData.floor?.toString())}</>}
                          </span>
                        </div>
                      </div>

                      <div className={`d-flex align-items-center justify-content-center my-md-2 my-3 mx-md-0 mx-3 ${Dstyles.facilities_card_container}`}>
                        <div className={`d-flex align-items-center justify-content-center ${Dstyles.icon_bg}`}>
                          <img src={calenderIcon} alt="icon" />
                        </div>
                        <div className="d-flex align-items-start justify-content-center flex-column me-3">
                          <span className={Dstyles.text_gray}>سال ساخت</span>
                          <span className={`me-0 mt-1 ${Dstyles.text_title_sm}`}>{e2p(fileData.constructionYear?.toString())}</span>
                        </div>
                      </div>

                      <div className={`d-flex align-items-center justify-content-center my-md-2 my-3 mx-md-0 mx-3 ${Dstyles.facilities_card_container}`}>
                        <div className={`d-flex align-items-center justify-content-center ${Dstyles.icon_bg}`}>
                          <img src={locationIcon} alt="icon" />
                        </div>
                        <div className="d-flex align-items-start justify-content-center flex-column me-3">
                          <span className={Dstyles.text_gray}>منطقه</span>
                          <span className={`me-0 mt-1 ${Dstyles.text_title_sm}`}>{e2p(fileData?.address?.zone?.toString())}</span>
                        </div>
                      </div>
                    </div>
                    <hr className="solid w-100" />
                    {/* </div> */}
                  </div>
                )}

                {props.landing ? (
                  <></>
                ) : (
                  <FileFacilities
                    addedFacilities={addedFacilities}
                    setAddedFacilities={setAddedFacilities}
                    facilitiData={facilitiData}
                    itemID={facilitiData}
                    addedFacilitiesID={addedFacilitiesID}
                    setAddedFacilitiesID={setAddedFacilitiesID}
                    cardData={fileData}
                  />
                )}

                {props.landing ? (
                  <div className="w-100 d-flex align-items-center justify-content-end my-3">
                    <div onClick={() => handleExternalLinkClick(fileData.otherSiteUrl)} className={Dstyles.text_primary} style={{ cursor: "pointer" }}>
                      مشاهده روی نقشه
                      <svg className="me-2" width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.233 0.454505C9.67233 0.893845 9.67233 1.60616 9.233 2.0455L4.40349 6.875H16.3125C16.9338 6.875 17.4375 7.37868 17.4375 8C17.4375 8.62132 16.9338 9.125 16.3125 9.125H4.40349L9.233 13.9545C9.67233 14.3938 9.67233 15.1062 9.233 15.5455C8.79366 15.9848 8.08134 15.9848 7.642 15.5455L0.892005 8.7955C0.452665 8.35616 0.452665 7.64384 0.892005 7.2045L7.642 0.454505C8.08134 0.015165 8.79366 0.015165 9.233 0.454505Z"
                          fill="#21409A"
                        />
                      </svg>
                    </div>
                  </div>
                ) : (
                  <div className="w-100 d-flex align-items-center justify-content-end my-3">
                    <Link
                      to={
                        props.myFiles
                          ? {
                              pathname: `/user-files-detail/${fileData.slug}`,
                              state: {
                                state: fileData,
                                isMine: props.myAds ? true : false,
                              },
                            }
                          : {
                              pathname: `/فایل/${fileData.slug}`,
                              state: {
                                state: fileData,
                              },
                            }
                      }
                      className={Dstyles.text_primary}>
                      مشاهده بیشتر
                      <svg className="me-2" width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.233 0.454505C9.67233 0.893845 9.67233 1.60616 9.233 2.0455L4.40349 6.875H16.3125C16.9338 6.875 17.4375 7.37868 17.4375 8C17.4375 8.62132 16.9338 9.125 16.3125 9.125H4.40349L9.233 13.9545C9.67233 14.3938 9.67233 15.1062 9.233 15.5455C8.79366 15.9848 8.08134 15.9848 7.642 15.5455L0.892005 8.7955C0.452665 8.35616 0.452665 7.64384 0.892005 7.2045L7.642 0.454505C8.08134 0.015165 8.79366 0.015165 9.233 0.454505Z"
                          fill="#21409A"
                        />
                      </svg>
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );

  function handleExternalLinkClick(url) {
    window.open(url, "_blank");
  }
};

export default FastViewModal;
